import React from 'react';
import {
  Tabs as MuiTabs,
  Tab,
  Divider,
  Box,
  Card,
} from '@material-ui/core';

function Tabs({
  tabs,
  tabsProps,
  children,
  childrenBoxProps,
}: any) {
  return (
    <>
      <MuiTabs
        scrollButtons="auto"
        textColor="secondary"
        variant="scrollable"
        {...tabsProps}
      >
        {tabs.map((tab: any) => <Tab variant="fullWidth" {...tab} />)}
      </MuiTabs>
      <Divider />
      <Box {...childrenBoxProps}>
        {children}
      </Box>
    </>
  );
}

export default Tabs;
